import { render, staticRenderFns } from "./CardSelect.vue?vue&type=template&id=5d764fef&scoped=true"
import script from "./CardSelect.vue?vue&type=script&lang=js"
export * from "./CardSelect.vue?vue&type=script&lang=js"
import style0 from "./CardSelect.vue?vue&type=style&index=0&id=5d764fef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d764fef",
  null
  
)

export default component.exports